<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>报价单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<div>
					<el-select v-model="query.orderCompanyId" placeholder="请选择公司" filterable>
						<el-option key="" label="请选择公司" value=""></el-option>
						<el-option v-for="item in queryCustomersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>&nbsp;
					<el-input v-model="query.productName" placeholder="产品型号" class="handle-input mr10" style ="width:200px;"></el-input>
					<el-date-picker
						type="datetime"
						placeholder="开始时间"
						v-model="query.createTimeStart"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker> &nbsp;
					<el-date-picker
						type="datetime"
						placeholder="结束时间"
						v-model="query.createTimeEnd"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker>&nbsp;
					<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				</div>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="orderNo" label="订单号" width="150"></el-table-column>
				<el-table-column prop="orderCompanyName" label="客户名称"></el-table-column>
				<el-table-column prop="total" label="型号数量" width="120"></el-table-column>
				<el-table-column prop="createTime" label="报价时间" width="180"></el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
						<el-button
							type="text"
							icon="el-icon-printer"
							@click = "exportContract(scope.$index, scope.row)"
							v-if="controll['export']"
						>导出</el-button>
						<!--<el-button
                            type="text"
                            icon="el-icon-news"
                            @click="hanleCancel(scope.$index, scope.row)"
                        >转单</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >新增报价单</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="订单基本信息" name="baseTab">
					<el-form ref="form" :model="form" label-width="100px" :rules="rules">
						<el-row>
							<el-col :span="12">
								<el-form-item label="客户名称" prop="orderCompanyId">
									<el-select v-model="form.orderCompanyId" placeholder="请选择公司" filterable @change="onChangeCompanyId">
										<el-option key="" label="请选择公司" value=""></el-option>
										<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="含税订单" v-if=showNoTax>
									<el-switch v-model="form.taxIncluded"></el-switch>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="经办人" prop="operator">
									<el-input v-model="form.operator"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="电话" prop="tel">
									<el-input v-model="form.tel"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="支付方式" prop="payType">
									<el-select v-model="form.payType" placeholder="请选择支付类型">
										<el-option key="" label="请选择支付类型" value=""></el-option>
										<el-option v-for="item in payTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="备注" prop="remark">
									<el-input type=textarea :rows=3 v-model="form.remark"> </el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="订单内容" name="detailTab">
					<el-form ref="detail" :model="detail" label-width="50px" :rules="detailRules">
						<el-row>
							<el-col :span="12">
								<el-form-item label="产品" prop="productInfo">
									<el-cascader
										:options="productOptions"
										v-model="detail.productInfo" filterable clearable style="width:250px">
									</el-cascader>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="单价" prop="price">
									<el-input v-model="detail.price"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="20">
								<el-form-item label="备注" prop="remark">
									<el-input type=textarea :rows=3 v-model="detail.remark"> </el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4" align = "center">
								<el-button type="primary" @click="addDetail" style="margin-top:35px">添加</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-row>
						<el-col :span="24">
							<el-table
								:data="orderDetails"
								border
								class="table"
								header-cell-class-name="table-header"
								:cell-style="{padding:1+'px'}"
								stripe
							>
								<el-table-column prop="id" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index + 1}}
									</template>
								</el-table-column>
								<el-table-column prop="seriesName" label="名称" width="200"></el-table-column>
								<el-table-column prop="productName" label="型号" width="150"></el-table-column>
								<el-table-column prop="price" label="单价" width="120"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
								<el-table-column prop="remark" label="备注"></el-table-column>
								<el-table-column label="操作" width="70" align="center">
									<template slot-scope="scope">
										<el-button
											type="text"
											icon="el-icon-delete"
											class="red"
											@click="removeDetail(scope.$index, scope.row)"
										>删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="订单信息" :visible.sync="showVisible" width="60%">
			<el-form ref="show" :model="show" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							客户名称
						</template>
						{{show.orderCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							经办人
						</template>
						{{show.operator}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							电话
						</template>
						{{show.tel}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							报价时间
						</template>
						{{show.createTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							编号
						</template>
						{{show.contractNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
				</el-descriptions>
				<el-row style="margin-top:20px">
					<el-table
						:data="orderShowDetails"
						border
						class="table"
						header-cell-class-name="table-header"
						:cell-style="{padding:1+'px'}"
						stripe
						sytle="padding-left:50px;padding-right:50px;"
					>
						<el-table-column prop="id" label="序号" width="50">
							<template slot-scope="scope">
								{{scope.$index + 1}}
							</template>
						</el-table-column>
						<el-table-column prop="seriesName" label="名称" width="200"></el-table-column>
						<el-table-column prop="productName" label="型号" width="140"></el-table-column>
						<el-table-column prop="price" label="单价" width="120"><template slot-scope="scope">￥{{scope.row.price}}</template></el-table-column>
						<el-table-column prop="remark" label="备注"></el-table-column>
					</el-table>
				</el-row>
			</el-form>
        </el-dialog>
    </div>
</template>

<script>
import bus from '../../common/bus';
import { getControll } from '../../../utils/controlls';
import { fetchQuotationData, quotation, getOrder, getCustomerKV, getAllCustomerKV, getAllProducts, getCustomer, exportContractById, isShowNoTax } from '../../../api/index';
export default {
    name: 'quotation',
    data() {
		let checkProductId = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请选择产品'));
			} else {
				if (value[2] === "") {
					callback(new Error('请选择产品'));
				} else {
					callback();
				}
			}
		}
		
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			rules: {
                orderCompanyId: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
				operator: [{ required: true, message: '经办人不能为空', trigger: 'blur' }],
				tel: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
				payType: [{required: true, message: '请选择支付方式', trigger: 'blur' }]
            },
			detailRules: {
                productInfo: [{ required: true, validator:checkProductId, trigger: 'blur' }],
				price: [{required: true, message: '单价不能为空', trigger: 'blur' }]
            },
			productOptions:[],
			customersKV:[],
			queryCustomersKV:[],
			detail:{},
			activeName:"baseTab",
			orderDetails:[],
			orderShowDetails:[],
			showVisible:false,
			show:{},
			payTypeConfig : {
								"0":"款到发货", 
								"1":"快递代收", 
								"2":"账期付款"
							},
			payTypeKV:[],
			title:"",
			showNoTax:false,
			controll:{}
        };
    },
    created() {
		this.controll=getControll("quotation");
		bus.$on('quotation', msg => {
            for (var key in msg) {
				this.$set(this.query, key, msg[key]);
			}
			this.getData();
        });
		this.getProducts();
		this.getAllCustomers();
		this.getCustomers();
		this.getShowNoTax();
        this.getData();
    },
    methods: {
		getShowNoTax() {
			isShowNoTax().then(res => {
				if (res.code == 0) {
					this.showNoTax = res.data;
				} else {
					this.$message.error(`获取显示配置失败！` + res.message);
				}
			});
		},
		//获取产品信息
		getChildrenLabel(children, index, names) {
			for (var i = 0; i < children.length; i++) {
				if (children[i].value === this.detail["productInfo"][index]) {
					names.push(children[i].label);
					if (null != children[i].children) {
						index ++;
						return this.getChildrenLabel(children[i].children, index, names);
					}
				}
			}
		},
		//添加详情
		addDetail() {
			this.$refs.detail.validate(valid => {
				if (valid) {
					let orderDetail = {};
					orderDetail["typeId"] = this.detail["productInfo"][0];
					orderDetail["seriesId"] = this.detail["productInfo"][1];
					orderDetail["productId"] = this.detail["productInfo"][2];
					let names = [];
					this.getChildrenLabel(this.productOptions, 0, names);
					//系列名称填充商品类型名称
					orderDetail["seriesName"] = names[0];
					orderDetail["productName"] = names[2];
					orderDetail["num"] = 1;
					orderDetail["unit"] = "个";
					orderDetail["price"] = this.detail["price"];
					orderDetail["amount"] = this.detail["price"];
					orderDetail["remark"] = this.detail["remark"];
					this.orderDetails.push(orderDetail);
					this.detail = {};
				} else {
					this.$message.error(`订单详情数据不完整！`);
				}
			})
		},
		//删除详情
		removeDetail(index, row) {
			this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let index = this.orderDetails.findIndex(item => {
						if (item.productId === row.productId && item.num === row.num 
						&& item.price === row.price && item.remark === row.remark) {
							return true;
						}
					});
					this.orderDetails.splice(index, 1);
                })
                .catch(() => {});
		},
		//公司变更
		onChangeCompanyId(value) {
			if (typeof(value) === "undefined" || value === "" ) {
				this.$set(this.form, "operator", "");
				this.$set(this.form, "tel", "");
				return;
			}
			getCustomer(value).then(res => {
				if (res.code == 0) {
					this.$set(this.form, "operator", res.data.base.contact);
					this.$set(this.form, "tel", res.data.base.tel);
					this.payTypeKV = [];
					for (var obj in this.payTypeConfig) {
						if ((typeof(res.data.base.accountPeriodDays) == "undefined" || res.data.base.accountPeriodDays === 0) && obj === "2") {
							continue;
						}
						let payTypeItem = {};
						payTypeItem["key"] = Number(obj);
						payTypeItem["value"] = this.payTypeConfig[obj] + (obj === "2"?" -- 账期剩余额度：" + res.data.periodBalance + "元":"");
						this.payTypeKV.push(payTypeItem);
					}
				} else {
					this.$message.error(`获取客户信息失败！` + res.message);
				}
			});
		},
		//获取产品信息
		getProducts() {
			getAllProducts(this.form).then(res => {
				if (res.code == 0) {
					this.productOptions = res.data;
				} else {
					this.$message.error(`获取产品信息失败！` + res.message);
				}
			})
		},
		//获取客户
		getCustomers() {
			getCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取客户信息失败！` + res.message);
				}
			});
		},
		getAllCustomers() {
			getAllCustomerKV().then(res => {
				if (res.code == 0) {
					this.queryCustomersKV = res.data;
				} else {
					this.$message.error(`获取客户信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchQuotationData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        //撤销订单
		hanleCancel(index, row) {
            // 二次确认撤销
            this.$confirm('确定要撤销此订单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {taxIncluded:true};
			this.orderDetails = [];
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.orderDetails = [];
			getOrder(row.id).then(res => {
				if (res.code == 0) {
					this.form["id"] = res.data.id;
					this.form["orderCompanyId"] = res.data.orderCompanyId;
					this.onChangeCompanyId(this.form["orderCompanyId"]);
					this.form["operator"] = res.data.operator;
					this.form["tel"] = res.data.tel;
					this.form["remark"] = res.data.remark;
					this.form["taxIncluded"] = res.data.taxIncluded;
					this.form["payType"] = res.data.payType;
					for (var i = 0; i < res.data.detailList.length; i++) {
						let orderDetail = {};
						let item = res.data.detailList[i];
						orderDetail["typeId"] = item["typeId"];
						orderDetail["seriesId"] = item["seriesId"];
						orderDetail["productId"] = item["productId"];
						orderDetail["seriesName"] = item["seriesName"];
						orderDetail["productName"] = item["productName"];
						orderDetail["num"] = item["num"];
						orderDetail["unit"] = item["unit"];
						orderDetail["price"] = item["price"];
						orderDetail["amount"] = item["amount"];
						orderDetail["remark"] = item["remark"];
						this.orderDetails.push(orderDetail);
					}
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		handleShow(index, row) {
			this.handleShowDetail(index, row);
		},
		handleShowDetail(index, row) {
			getOrder(row.id).then(res => {
				if (res.code == 0) {
					this.show = res.data;
					this.orderShowDetails = res.data.detailList;
					this.showVisible = true;
				} else {
					this.$message.error(`获取订单详情失败！` + res.message);
				}
			})
		},
		handleSelectionChange(val) {
            this.stockSelection = val;
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.form["detailList"] = this.orderDetails;
					let index = this.customersKV.findIndex(item => {
						if (item.key === this.form["orderCompanyId"]) {
							return true;
						}
					})
					this.form["orderCompanyName"] = this.customersKV[index].value;
					quotation(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		exportContract(index, row){
			exportContractById(row.id).then(res => {
				if (res.code == 0) {
					this.$router.push({path: "export-quotation", query:{key: res.data}});
				} else {
					this.$message.error(`生成合同失败！` + res.message);
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    width: 40px;
    height: 30px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.text {
	font-size: 14px;
}

.item {
	margin-bottom: 18px;
	border-bottom:1px solid #E0E0E0;
}
</style>
